import React from 'react'

import { AccessPassCard } from '../../AccessPassCard'

export default function AccessPassListItem({ accessPass, onTransferred }) {
  return (
    <AccessPassCard accessPass={accessPass} onTransferred={onTransferred} />
  )
}
